import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-full-page-layout',
    templateUrl: './full-page-layout.component.html',
    styleUrls: ['./full-page-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FullPageLayoutComponent {}
